@if (quoteRequestForm !== undefined && selectedStateBond() !== null &&
sectionHasQuestions('screening', selectedStateBond())) {
<form [formGroup]="quoteRequestForm" class="cipx-form-section">
  <fieldset>
    <legend class="cipx-form-section-title">Quick Questions</legend>

    <cipx-quote-request-intake-form-question-set
      [quoteRequestForm]="quoteRequestForm"
      [stateBond]="selectedStateBond()"
      layoutName="screening"></cipx-quote-request-intake-form-question-set>
  </fieldset>
</form>
}
